import { Box } from '@mui/material';
import { ClientStepProps } from '../../types';
import { displayBoolean } from '../../../common/helpers/displayBoolean';
import { formatAmount } from '../../../common/components/dataGrid/dataGridEditNumberCell';
import { JSX } from 'react';
import { MARRIED_MARITAL_STATUS_ID } from '../../constants';
import { NaturalPerson } from '../../../common/types/client';
import PolicyCard from '../../../common/components/policyCard';

/**
 * Natural person rating details step
 */
const RatingDetailsStep = ({ client }: ClientStepProps<NaturalPerson>): JSX.Element => {
  return (
    <Box>
      <PolicyCard
        sectionsClassName="grid md:grid-cols-2 gap-6"
        sections={[
          {
            topBorder: false,
            caption: 'Basic',
            items: [
              { name: 'Used tobacco in last 6 months', value: displayBoolean(client.tobacco) },
              { name: 'Weight', value: `${client.weight} kg` },
              { name: 'Height', value: `${client.height} cm` },
              { name: 'BMI', value: client.bmi },
            ],
          },
          {
            topBorder: false,
            caption: 'Education and employment',
            items: [
              { name: 'Highest education level', value: client.educationNote },
              { name: 'Occupation', value: client.occupationNote },
              { name: 'Gross monthly income', value: formatAmount(client.income) },
              { name: 'Self-employed', value: displayBoolean(client.selfemployed) },
            ],
          },
          ...(client.maritalStatusID === MARRIED_MARITAL_STATUS_ID
            ? [
                {
                  topBorder: false,
                  caption: 'Spouse education and employment',
                  items: [
                    { name: 'Highest education level', value: client.spouseEducationNote },
                    { name: 'Self-employed', value: displayBoolean(client.spouseIsSelfEmployed) },
                    {
                      name: 'Gross monthly income',
                      value: formatAmount(client.spouseIncome),
                    },
                    { name: 'Occupation', value: client.spouseOccupationNote },
                  ],
                },
              ]
            : []),
        ]}
      />
    </Box>
  );
};

export default RatingDetailsStep;
